<template>
  <LayoutGridBox :permalink="permalink" :label="name">
    <LayoutGridBoxImageSection :src="logo" :alt="name" :sizes="sizes" />

    <h5 class="mt-auto font-bold">
      {{ name }}
    </h5>
  </LayoutGridBox>
</template>

<script setup lang="ts">
import type { QueryBrands } from "~/@types/brands"

const props = defineProps<{
  brand: QueryBrands
}>()

const { brand } = toRefs(props)

const { name, logo, permalink } = useBrand(brand.value)
const { sizes } = useImageInfo(logo)
</script>
